import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

const BASE_URL = `https://api.dilanaslan.com/api/services`;

// Tüm yorumları çek
export const fetchServices = createAsyncThunk(
  "services/fetchServices",
  async () => {
    const res = await axios.get(BASE_URL);
    return res.data;
  }
);

// Yorum ID'ye göre getir
export const fetchServiceById = createAsyncThunk(
  "services/fetchById",
  async (id) => {
    const res = await axios.get(`${BASE_URL}/${id}`);
    return res.data;
  }
);

// Yeni yorum oluştur
export const createService = createAsyncThunk(
  "services/createService",
  async (newService) => {
    const res = await axios.post(BASE_URL, newService);
    return res.data;
  }
);

// Yorum güncelle
export const updateService = createAsyncThunk(
  "services/updateService",
  async ({ id, updatedService }) => {
    const res = await axios.put(`${BASE_URL}/${id}`, updatedService);
    return res.data;
  }
);

// Yorum sil
export const deleteService = createAsyncThunk(
  "services/deleteService",
  async (id) => {
    await axios.delete(`${BASE_URL}/${id}`);
    return id;
  }
);

const servicesSlice = createSlice({
  name: "services",
  initialState: {
    services: [],
    selectedService: null,
    loading: false,
    error: null,
  },
  reducers: {
    clearSelectedService: (state) => {
      state.selectedService = null;
    },
  },
  extraReducers: (builder) => {
    builder
      // Fetch all
      .addCase(fetchServices.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchServices.fulfilled, (state, action) => {
        state.loading = false;
        state.services = action.payload.services || [];
      })
      .addCase(fetchServices.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })

      // Fetch by ID
      .addCase(fetchServiceById.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchServiceById.fulfilled, (state, action) => {
        state.loading = false;
        state.selectedService = action.payload;
      })
      .addCase(fetchServiceById.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })

      // Create
      .addCase(createService.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(createService.fulfilled, (state, action) => {
        state.loading = false;
        state.services.unshift(action.payload);
      })
      .addCase(createService.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })

      // Update
      .addCase(updateService.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(updateService.fulfilled, (state, action) => {
        state.loading = false;
        const index = state.services.findIndex(
          (item) => item._id === action.payload._id
        );
        if (index !== -1) {
          state.services[index] = action.payload;
        }
        if (
          state.selectedService &&
          state.selectedService._id === action.payload._id
        ) {
          state.selectedService = action.payload;
        }
      })
      .addCase(updateService.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })

      // Delete
      .addCase(deleteService.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(deleteService.fulfilled, (state, action) => {
        state.loading = false;
        state.services = state.services.filter(
          (item) => item._id !== action.payload
        );
      })
      .addCase(deleteService.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      });
  },
});

export const { clearSelectedService } = servicesSlice.actions;
export default servicesSlice.reducer;
